import { chargeTypes } from "helpers/constants";

const useChargeTypes = (type) => {
  const isBasic = type === chargeTypes.BASIC;
  const isFee = type === chargeTypes.FEE;

  return { isBasic, isFee };
};

export default useChargeTypes;